const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20celebrity%20gossip%20magazine%20cover%20concept%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20elegant%20mysterious%20atmosphere%2C%20luxury%20lifestyle%20elements%2C%20editorial%20photography%20style%2C%20simple%20background&width=800&height=560&seq=card-01&orientation=landscape',
    tag: '独家',
    title: '揭秘某顶流与经纪公司的合约纠纷细节',
    desc: '天价违约金、霸王条款、私下和解……当红艺人与公司之间的博弈远比想象中复杂。',
    time: '3小时前',
    alt: '911吃瓜网独家揭秘顶流合约纠纷',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20insider%20document%20concept%2C%20vintage%20newspaper%20clippings%20aesthetic%2C%20warm%20sepia%20tones%2C%20dramatic%20shadows%2C%20investigative%20journalism%20atmosphere%2C%20clean%20minimal%20background&width=800&height=560&seq=card-02&orientation=landscape',
    tag: '深扒',
    title: '影视圈选角潜规则：那些被换掉的演员们',
    desc: '资本干涉、关系户空降、临时换角……影视作品背后的演员更替远比剧本更精彩。',
    time: '6小时前',
    alt: '911吃瓜网深扒影视圈选角潜规则',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Red%20carpet%20fashion%20event%2C%20glamorous%20celebrity%20style%2C%20warm%20spotlight%2C%20luxury%20atmosphere%2C%20golden%20hour%20lighting%2C%20high%20fashion%20editorial%20photography%2C%20neutral%20elegant%20backdrop&width=800&height=560&seq=card-03&orientation=landscape',
    tag: '盘点',
    title: '明星素颜与精修照对比：差距能有多大？',
    desc: '红毯上的光鲜亮丽 vs 生活中的真实模样，明星素颜对比永远是吃瓜群众的最爱。',
    time: '9小时前',
    alt: '911吃瓜网明星素颜精修对比盘点',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20controversy%20concept%20art%2C%20dramatic%20warm%20lighting%2C%20abstract%20conflict%20visualization%2C%20trending%20topic%20representation%2C%20dark%20background%20with%20warm%20red%20accents%2C%20editorial%20style&width=800&height=560&seq=card-04&orientation=landscape',
    tag: '追踪',
    title: '某知名品牌连夜删除代言人全部物料',
    desc: '从官宣到解约仅48小时，品牌与明星的合作为何越来越短命？背后原因值得深思。',
    time: '12小时前',
    alt: '911吃瓜网追踪品牌解约风波',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20relationship%20rumors%20concept%2C%20romantic%20dramatic%20atmosphere%2C%20warm%20golden%20and%20rose%20tones%2C%20elegant%20couple%20silhouette%2C%20luxury%20lifestyle%20aesthetic%2C%20soft%20natural%20lighting&width=800&height=560&seq=card-05&orientation=landscape',
    tag: '热议',
    title: '今年最让人意外的5对明星CP实锤汇总',
    desc: '从最不被看好到甜蜜官宣，这些明星恋情的反转程度堪比偶像剧剧本。',
    time: '1天前',
    alt: '911吃瓜网明星CP实锤汇总',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20award%20show%20ceremony%2C%20grand%20stage%20with%20golden%20lights%2C%20dramatic%20atmosphere%2C%20prestigious%20event%20photography%2C%20warm%20luxurious%20tones%2C%20editorial%20composition%2C%20clean%20backdrop&width=800&height=560&seq=card-06&orientation=landscape',
    tag: '回顾',
    title: '那些年轰动全网的十大娱乐圈大事件回顾',
    desc: '从微博瘫痪到全民讨论，这些热点事件至今仍被吃瓜群众津津乐道。',
    time: '2天前',
    alt: '911吃瓜网娱乐圈大事件回顾',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">深度爆料</h2>
          <span className="text-xs text-foreground-400">独家深挖内容</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#cards"
              className="group block rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2.5 left-2.5">
                  <span className="text-[10px] font-bold text-background-50 bg-primary-500/90 px-2 py-1 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">{card.desc}</p>
                <span className="text-xs text-foreground-400">{card.time}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}